'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMatchExpression = transformMatchExpression;
exports.transformMatchStatement = transformMatchStatement;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _blocks = require('./blocks');

var _is = require('./is');

var _ref5 = require('./ref');

var _destructure = require('./destructure');

var _logical = require('./logical');

var _runtime = require('./runtime');

var _variables = require('./variables');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function isUndefined(node) {
  return node.type === "Identifier" && node.name === "undefined";
}function isSignedNumber(node) {
  return node.type === "UnaryExpression" && (node.operator === "+" || node.operator === "-") && node.argument.type === "NumericLiteral";
}function transformGuardId(idPath, bindingAccessors) {
  var node = idPath.node;

  if (node._guardWasTransformed) return; // Prevent infinite recursion

  if (bindingAccessors[node.name]) {
    var loc = (0, _astLocUtils.getLoc)(node);
    var replacement = _types2.default.cloneDeep(bindingAccessors[node.name]);
    (0, _astLocUtils.traverse)(replacement, function (n) {
      // Prevent infinite recursion
      if (n.type === "Identifier") n._guardWasTransformed = true;
      return (0, _astLocUtils.placeAtLoc)(n, loc);
    });
    return idPath.replaceWith(replacement);
  }
}function transformInnerGuard(mtch, path, bindingAccessors) {
  path.traverse({
    ReferencedIdentifier(idPath) {
      if (!(0, _variables.checkFalsePositiveReference)(idPath)) {
        transformGuardId(idPath, bindingAccessors);
      }
    } });
  return path.node;
}function transformPredicate(mtch, path) {
  var discriminantRef = mtch.discriminantRef;

  path.traverse({
    MatchPlaceholderExpression(phPath) {
      return phPath.replaceWith(discriminantRef);
    } });
  return path.node;
}function isStrictEqualityLiteral(node) {
  return isSignedNumber(node) || isUndefined(node) || (0, _is.isa)(node, "Literal") && !(0, _is.isa)(node, "RegExpLiteral");
}function isPredicate(node) {
  return (0, _is.isa)(node, "CallExpression");
}function transformAtom(mtch, path) {
  var discriminantRef = mtch.discriminantRef;
  var node = path.node;

  if ((0, _is.isa)(node, "LogicalExpression")) {
    node.left = transformAtom(mtch, path.get("left"));
    node.right = transformAtom(mtch, path.get("right"));
    return node;
  } else if ((0, _is.isa)(node, "UnaryExpression") && node.operator === "!") {
    var _operator = node.operator;

    node.argument = transformAtom(mtch, path.get("argument"));
    return node;
  } else if (isStrictEqualityLiteral(node)) {
    return (0, _astLocUtils.placeAtNode)(_types2.default.binaryExpression("===", discriminantRef, node), node);
  } else if (isPredicate(node)) {
    return transformPredicate(mtch, path);
  } else {
    return (0, _astLocUtils.placeAtNode)(_types2.default.callExpression((0, _astLocUtils.placeAtNode)(_types2.default.clone((0, _runtime.runtime)('isMatch')), node), [node, discriminantRef]), node);
  }
}function transformAtoms(mtch, atomPaths) {
  return (0, _logical.createOrExpression)(function () {
    var _arr = [];for (var _i2 = 0, _len2 = atomPaths.length; _i2 < _len2; _i2++) {
      var _atomPath = atomPaths[_i2];_arr.push(transformAtom(mtch, _atomPath));
    }return _arr;
  }());
}function transformMatchTest(mtch, casePath) {
  var _casePath$node = casePath.node,
      outerGuard = _casePath$node.outerGuard,
      atoms = _casePath$node.atoms,
      binding = _casePath$node.binding,
      assertive = _casePath$node.assertive,
      innerGuard = _casePath$node.innerGuard;
  var discriminantRef = mtch.discriminantRef;


  return (0, _logical.createAndExpression)(function () {
    var _arr2 = [];
    if (outerGuard) _arr2.push(outerGuard);
    if (atoms && atoms.length > 0) {
      _arr2.push(transformAtoms(mtch, casePath.get("atoms")));
    }if (binding && assertive) {
      _arr2.push((0, _destructure.matchesDestructuringPattern)(discriminantRef, binding));
    }if (innerGuard) {
      if (binding) {
        // Transform referenced identifiers in the inner guard into accessors
        // into the matched pattern.
        var bindingAccessors = {};
        (0, _destructure.accessors)(binding, discriminantRef, bindingAccessors);
        _arr2.push(transformInnerGuard(mtch, casePath.get("innerGuard"), bindingAccessors));
      } else {
        _arr2.push(innerGuard);
      }
    }return _arr2;
  }());
}function transformBoundConsequent(_ref2, binding, consequent, innerGuard) {
  var discriminantRef = _ref2.discriminantRef,
      isLinter = _ref2.isLinter;

  var block = (0, _blocks.toBlockStatement)(consequent);

  // Linter: duplicate innerGuard inside consequent to quiet noUnusedVars errors.
  if (isLinter && innerGuard) {
    block.body.unshift((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.ifStatement(_types2.default.cloneDeep(innerGuard), _types2.default.expressionStatement(_types2.default.booleanLiteral(true))), (0, _astLocUtils.getLoc)(innerGuard)));
  }block.body.unshift((0, _astLocUtils.placeAtNode)(_types2.default.variableDeclaration("const", [(0, _astLocUtils.placeAtNode)(_types2.default.variableDeclarator(binding, discriminantRef), binding)]), binding));
  return block;
}function transformMatchConsequent(mtch, casePath) {
  var _casePath$node2 = casePath.node,
      binding = _casePath$node2.binding,
      consequent = _casePath$node2.consequent,
      innerGuard = _casePath$node2.innerGuard;

  if (binding && (0, _destructure.isNonEmptyPattern)(binding)) {
    return transformBoundConsequent(mtch, binding, consequent, innerGuard);
  } else {
    return (0, _blocks.toBlockStatement)(consequent);
  }
}function transformMatchCase(mtch, casePath) {
  var _ref;

  var c = casePath.node;
  return {
    consequent: transformMatchConsequent(mtch, casePath),
    test: ((_ref = c.outerGuard) == null ? null : _ref.type) !== "MatchElse" ? transformMatchTest(mtch, casePath) : null
  };
}function transformMatchCases(mtch, _ref3) {
  var _ref4 = _toArray(_ref3),
      casePath = _ref4[0],
      rest = _ref4.slice(1);

  var c = casePath.node;

  var _transformMatchCase = transformMatchCase(mtch, casePath),
      test = _transformMatchCase.test,
      consequent = _transformMatchCase.consequent;

  if (rest.length > 0) {
    var loc = (0, _astLocUtils.getSurroundingLoc)([c, mtch.lastCase]);
    return (0, _astLocUtils.placeAtLoc)(_types2.default.ifStatement(test, consequent, transformMatchCases(mtch, rest)), loc);
  } else if (test) {
    return (0, _astLocUtils.placeAtNode)(_types2.default.ifStatement(test, consequent), c);
  } else {
    return consequent;
  }
} // Computed values needed in recursive descent.
function getMatchInfo(path, discriminantRef, isLinter) {
  var node = path.node;

  return {
    path, node, discriminantRef
    // Track last case for source map positioning
    , lastCase: node.cases[node.cases.length - 1],
    isLinter
  };
}function transformMatchExpression(path, isLinter) {
  var node = path.node;


  var argRef = (0, _astLocUtils.placeAtLoc)(path.scope.generateUidIdentifier("it"), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));
  var matchBody = transformMatchCases(getMatchInfo(path, argRef, isLinter), path.get("cases"));

  var iife = (0, _astLocUtils.placeAtNode)(_types2.default.callExpression((0, _astLocUtils.placeAtNode)(_types2.default.arrowFunctionExpression([argRef], (0, _astLocUtils.placeAtNode)(_types2.default.blockStatement([matchBody]), node)), node), [node.discriminant]), node);

  return path.replaceWith(iife);
}function transformMatchStatement(path, isLinter) {
  var discriminant = path.node.discriminant;

  var _undeclaredRef = (0, _ref5.undeclaredRef)(path, discriminant, "it"),
      ref = _undeclaredRef.ref,
      declarator = _undeclaredRef.declarator,
      isComplex = _undeclaredRef.isComplex;

  if (isComplex) {
    path.insertBefore((0, _astLocUtils.placeAtNode)(_types2.default.variableDeclaration("const", [declarator]), declarator));
  }return path.replaceWith(transformMatchCases(getMatchInfo(path, ref, isLinter), path.get("cases")));
}